import { interpolate } from './interpolate';

/**
 * Devuelve la cadena traducida y interpolada si tiene variables.
 *
 * @param {Object} state
 * @param {string|Object} key la clave de la cadena, o un objeto {key: params} ej. { "global.min": { min: 2 } }
 * @param {Object} [params] el objeto con los valores de las variables a interpolar
 * @param {string} [defaultValue] el valor por defecto si "Error not found" sino especificado, devuelve el `key` buscado
 * @returns {Object<string, string>} objeto {key: tradución}, ej. {'global.ok': "Acceptar"}
 */

export function translateOne(dictionary, key, params, defaultValue) {
  if (typeof key === 'object') {
    const extracted = extractObject(key, params);
    key = extracted.key;
    params = extracted.params;
  }

  return getKeyValue(dictionary, key, params, defaultValue);
}

/**
 * Devuelve la clave y los parametros.
 *
 * @param {Object} cur el objeto {key: params} a traducir
 * @param {Object} [globalParams={}] parametros globales
 * @returns {Object<string, Object>}
 */
function extractObject(cur, globalParams = {}) {
  const [key, localeParams] = Object.entries(cur)[0];

  if (typeof localeParams !== 'object') {
    throw new TypeError(`"${key}" is type of "${typeof localeParams}",  must be an "object"`);
  }

  const params = Object.assign({}, globalParams, localeParams);
  return { key, params };
}

/**
 * Devuelve el objeto de traducción de una clave, con parametros opcionales.
 *
 * @param {Object} dictionary el objeto con las traducciones
 * @param {string} key la clave de la cadena
 * @param {Object} [params={}] las variables de la cadena
 * @param {string} [defaultValue] el valor por defecto si "Error not found" sino especificado, devuelve el `key` buscado
 * @returns {Object<string, string|undefined>} objeto {key: tradución}, ej. {'global.ok': "Acceptar"}
 */
function getKeyValue(dictionary, key, params, defaultValue) {
  const traduction = translate(dictionary, key, params, defaultValue);
  return { [key]: traduction };
}

/**
 * Devuelve la traducción de una clave, con parametros opcionales.
 *
 * @param {Object} dictionary el objeto con las traducciones
 * @param {string} key la clave de la cadena
 * @param {Object} [params={}] las variables de la cadena
 * @param {string} [defaultValue] el valor por defecto si "Error not found" sino especificado, devuelve el `key` buscado
 * @returns {string|undefined}
 */
function translate(dictionary, key, params, defaultValue) {
  const template = dictionary?.[key] ?? defaultValue;
  // Nota que template puede ser "" (en especial por defaultValue) y es valido
  if (typeof template !== 'string') {
    // si "Error not found", devolvemos undefined
    return;
  }

  return interpolate(template, params);
}
